import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/reset-password/resetPassword')({
  beforeLoad: () => {
    const searchParams = new URL(window.location.href).searchParams;
    const token = searchParams.get('token');
    const twoFa = searchParams.get('2fa');

    throw redirect({
      to: '/auth/reset-password',
      replace: true,
      search: {
        token: token ?? '',
        '2fa': twoFa === 'true',
      },
    });
  },
});
